'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookieBrowserApi = require('./cookieBrowserApi.js');

var cookieBrowserApi = _interopRequireWildcard(_cookieBrowserApi);

var _cookieInMemoryApi = require('./cookieInMemoryApi.js');

var _cookieInMemoryApi2 = _interopRequireDefault(_cookieInMemoryApi);

var _cookieNames = require('../configs/cookieNames.js');

var _featureDetection = require('./featureDetection.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CookieApi = function () {
    function CookieApi(cookies, env) {
        _classCallCheck(this, CookieApi);

        if ((0, _featureDetection.isServer)()) {
            cookies = cookies || '';
            this._api = new _cookieInMemoryApi2.default(cookies);
        } else {
            this._api = cookieBrowserApi;
        }
        this._env = env;
    }

    _createClass(CookieApi, [{
        key: 'getAnalyticsCookie',
        value: function getAnalyticsCookie() {
            return this._api.getAnalyticsCookie();
        }
    }, {
        key: 'getAbCookie',
        value: function getAbCookie() {
            return this._api.getAbCookie();
        }
    }, {
        key: 'getKissmetricsCookie',
        value: function getKissmetricsCookie() {
            return this._api.getKissmetricsCookie();
        }
    }, {
        key: 'getCookieString',
        value: function getCookieString() {
            return this._api.getCookieString();
        }
    }, {
        key: 'getAuthUserEmail',
        value: function getAuthUserEmail() {
            var authCookieEnvMap = {
                'PROD': _cookieNames.COOKIE_NAMES.GGASPXAUTH_PROD_ID,
                'STAGING': _cookieNames.COOKIE_NAMES.GGASPXAUTH_STAGING_ID,
                'DEV': _cookieNames.COOKIE_NAMES.GGASPXAUTH_DEV_ID,
                'SANDBOX': _cookieNames.COOKIE_NAMES.GGASPXAUTH_SANDBOX_ID
            };

            return this._api.getAuthUserEmail(authCookieEnvMap[this._env]);
        }
    }, {
        key: 'getKOALAEmailIdentity',
        value: function getKOALAEmailIdentity() {
            return this._api.getKOALAEmailIdentity();
        }
    }, {
        key: 'setAnalyticsCookie',
        value: function setAnalyticsCookie(logged_out_cookie, logged_in_cookie) {
            this._api.setAnalyticsCookie(logged_out_cookie, logged_in_cookie);
        }
    }, {
        key: 'setKOALAEmailIdentity',
        value: function setKOALAEmailIdentity(email) {
            this._api.setKOALAEmailIdentity(email);
        }
    }, {
        key: 'setCookie',
        value: function setCookie(name, value) {
            this._api.setCookie(name, value);
        }
    }]);

    return CookieApi;
}();

exports.default = CookieApi;


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/lib/cookieApi.js